import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminPage from "@/pages/AdminPage";
import { ChatWidget } from "@/components/site/ChatWidget";
import { Toaster } from "sonner";
import { startLenis } from "@/lib/site";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { ServiceMenu } from "@/components/site/ServiceMenu";
import { Steps } from "@/components/site/Steps";
import { Zones } from "@/components/site/Zones";
import { QuoteForm } from "@/components/site/QuoteForm";
import { Footer } from "@/components/site/Footer";
import { Tray } from "@/components/site/Tray";

function Home() {
  const [selected, setSelected] = useState([]);
  const toggle = (id) => setSelected((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  const add = (id) => setSelected((s) => (s.includes(id) ? s : [...s, id]));
  const clear = () => setSelected([]);

  useEffect(() => {
    const stop = startLenis();
    return () => stop();
  }, []);

  return (
    <div className="site">
      <Nav count={selected.length} />
      <main>
        <Hero />
        <Marquee />
        <ServiceMenu selected={selected} onToggle={toggle} />
        <Steps />
        <Zones />
        <QuoteForm selected={selected} onToggle={toggle} onClear={clear} />
      </main>
      <Footer />
      <Tray selected={selected} onClear={clear} />
      <ChatWidget selected={selected} onAdd={add} />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      <Toaster position="top-center" theme="dark" richColors />
    </BrowserRouter>
  );
}

export default App;
